export default __webpack_public_path__ + "imgs/price.369be4ac1120b25a6879b355281e713e.svg";